import React from 'react';

export const Icon = () => (
  <div className="d-inline hdricon">
    <img className="d-none d-md-inline" src="/images/worldvue-hub-black[47].png" />
    <img className="d-none d-inline d-md-none" src="/images/worldvueicon.svg" />
  </div>
);
